import styled from 'styled-components';
import Box from '@material-ui/core/Box';

const Wrapper = styled(Box)``;

const Styled = { Wrapper };

export default Styled;
